import { SelectOption } from './select-option';

export interface SortParam {
  label: string;
  field: string;
  direction: -1 | 1;
}

export const sortParams: SortParam[] = [
  {
    label: 'Date - Newest',
    field: 'listingDate',
    direction: -1,
  },
  {
    label: 'Date - Oldest',
    field: 'listingDate',
    direction: 1,
  },
  {
    label: 'Price - Lowest',
    field: 'price',
    direction: 1,
  },
  {
    label: 'Price - Highest',
    field: 'price',
    direction: -1,
  },
  {
    label: 'Mileage - Lowest',
    field: 'mileage',
    direction: 1,
  },
  {
    label: 'Mileage - Highest',
    field: 'mileage',
    direction: -1,
  },
  {
    label: 'Year - Newest',
    field: 'year',
    direction: -1,
  },
  {
    label: 'Year - Oldest',
    field: 'year',
    direction: 1,
  },
];

export const sortOptions: SelectOption[] = sortParams.map((x, idx) => ({
  id: idx.toString(),
  label: x.label,
}));
